import { QueryClient } from '@tanstack/react-query';

import { AxiosError, isAxiosError } from 'axios';

export const isForbiddenError = (error: unknown): boolean =>
  isAxiosError(error) && error.response?.status === 403;

export const isUnauthorizedError = (error: unknown): boolean =>
  isAxiosError(error) && error.response?.status === 401;

export const isNotFoundError = (error: unknown): boolean =>
  isAxiosError(error) && error.response?.status === 404;

const retry = (failureCount: number, error: AxiosError | Error | unknown) => {
  const status = isAxiosError(error) ? error.response?.status : null;

  // no retry for status code 400...499
  if (status && status >= 400 && status < 500) {
    return false;
  }
  return failureCount < 1;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry
    },
    mutations: {
      retry
    }
  }
});
